module.exports = __webpack_public_path__ + "img/selected7-min.0e86e576.png";